module.exports = "<app-navbar></app-navbar>\n\n<div class=\"container viewPort\" [@routerTransition]=\"getState(o)\">\n  <router-outlet #o=\"outlet\"></router-outlet>\n</div>\n\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main